import React from 'react';
import { Trans } from '@lingui/react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';

import Button, { BUTTON_STYLES } from '../../../button/button';

const CloseButton = ({
    closeHandler,
    i18n
}) => (<Button
    buttonStyle={BUTTON_STYLES.iconBackground}
    importedClasses="button--close"
    callback={closeHandler}
    ariaProps={{ 'aria-label': i18n._(t`Modal - Close pop-up`) }}
    title={<Trans id={'Modal - Close pop-up'} />} />);

CloseButton.propTypes = {
    i18n: PropTypes.object,
    closeHandler: PropTypes.func.isRequired
};


export default CloseButton;



// WEBPACK FOOTER //
// ./components/generic-modal/components/close-button/close-button.js